import React, { Component } from 'react';
import throttle from 'lodash/throttle';

import 'react-table/react-table.css';

import * as notificationActions from 'actions/notificationActions';
import * as landlordTenantsActions from 'actions/landlordTenantsActions';
import * as landlordApplicationsActions from 'actions/landlordApplicationsActions';
import * as landlordPropertiesActions from 'actions/landlordPropertiesActions';
import * as companyDetailsActions from 'actions/companyDetailsActions';
import { getAllDocumentTemplates } from 'actions/landlordDocumentTemplatesActions';

import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import { destroy, change, formValueSelector } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';

import AllowTenantsYearlyRenewalsWizardPage from './renewal_creator/allowTenantsYearlyRenewalsWizardPage';
import CompanyAddressWizardPage from '../../applications/components/lease_creator/companyAddressWizardPage';
import LeaseTermWizardPage from '../../applications/components/lease_creator/leaseTermsWizardPage';
import ScheduleWizardPage from '../../applications/components/lease_creator/scheduleWizardPage';
import LeasePricingWizardPage from '../../applications/components/lease_creator/leasePricingWizardPage';
import RentalIncentiveWizardPage from '../../applications/components/lease_creator/rentalIncentiveWizardPage';
import ServicesAndUtilitiesWizardPage from 'components/landlord_app/applications/components/lease_creator/servicesAndUtilitiesWizardPage';
import ReviewWizardPage from './renewal_creator/reviewWizardPage';
import DocumentPortalSwitcher from '../../../../components/byesign/documentPortalSwitcher';
import LeaseDocumentsWizardPage from 'components/landlord_app/applications/components/lease_creator/leaseDocumentsWizardPage';
import FooterButtons from 'components/shared/FooterButtons';

import { tenantsHaveEmails } from 'helpers/EmailChecker';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import get from 'lodash/get';

export const PAGES = {
  COMPANY_ADDRESS: 0,
  YEARLY_RENEWALS: 1,
  LEASE_TERM: 2,
  SCHEDULE: 3,
  LEASE_PRICING: 4,
  RENTAL_INCENTIVE: 5,
  SERVICES_AND_UTILITIES: 6,
  LEASE_DOCUMENTS: 7,
  REVIEW: 8,
  DOCUMENT_PORTAL_IN_PERSON: 10,
  DOCUMENT_PORTAL_SWITCHER: 11,
};

export default connect(
  (store) => {
    const selector = formValueSelector('renewal_creator_form');

    return {
      showPage: store.authentication.showPage,
      leaseDetails: store.landlordTenants.leaseDetails,
      showScheduleAForm: store.landlordApplications.showScheduleAForm,
      scheduleAs: store.landlordApplications.scheduleAs,
      documentToSign:
        store.renewalLeaseWizard.documentToSign || store.landlordTenants.documentToSign,
      pageNumber: store.landlordTenants.pageNumber,
      backToReview: store.landlordTenants.backToReview,
      showN1NextQuestion: store.landlordTenants.showN1NextQuestion,
      signatureRenewalYearly: store.renewalLeaseWizard.signatureRenewalYearly,
      signatureRenewalMonthly: store.renewalLeaseWizard.signatureRenewalMonthly,
      is_in_person_signing: store.landlordTenants.is_in_person_signing,
      companyAddress: store.companyDetails.address,
      currentLeasesOfUnit: store.landlordProperties.currentLeasesOfUnit,
      unitDetails: store.landlordProperties.unit,
      selectedRentAmount: selector(store, 'monthly_rent'),
      selectedProperty: selector(store, 'property'),
    };
  },
  {
    ...landlordApplicationsActions,
    destroy,
    ...notificationActions,
    ...landlordTenantsActions,
    ...companyDetailsActions,
    ...landlordPropertiesActions,
    change,
    getAllDocumentTemplates,
  }
)(
  class RenewalCreator extends Component {
    state = {
      validationErrors: {},
    };

    componentDidMount = () => {
      if (!this.props.leaseDetails) {
        browserHistory.push('/companies/rent_roll');
        return;
      }
      this.props.getCurrentLeasesOfUnit(this.props.leaseDetails.unit_id);
      this.props.getAllDocumentTemplates();

      if (this.props.leaseDetails.unit_id) {
        this.props.getUnit(this.props.leaseDetails.unit_id, { is_renewal: true });
      }
      this.props.getScheduleAs(this.props.leaseDetails.lease_id);
      this.skipCompanyAddressPage();
      if (this.props.leaseDetails.is_manual_renewal) {
        this.props.goToPage(PAGES.LEASE_TERM);
      }
    };

    skipCompanyAddressPage = () => {
      if (!this.props.documentToSign) {
        if (this.props.companyAddress === null) {
          this.props.goToPage(PAGES.COMPANY_ADDRESS);
        } else {
          this.props.goToPage(PAGES.YEARLY_RENEWALS);
        }
      }
    };

    submitRenewal = (values) => {
      if (featureEnabled('custom_lease_creator')) {
        return this.props.putRenewal(values, this.props.leaseDetails.lease_id);
      }
      this.props.putRenewal(values, this.props.leaseDetails.lease_id);
      this.props.displayLoader(
        getTranslatedString('landlordPortal.renewalCreator.updateYourRenewal')
      );
      this.props.destroy('renewal_creator_form');
    };

    goToRentRollPage = () => {
      this.props.destroy('renewal_creator_form');
      browserHistory.push('/companies/rent_roll');
    };

    displayCertifcateOfService = () => {
      this.props.displayLoader(
        getTranslatedString('landlordPortal.renewalCreator.retrieveCertificate')
      );
      this.props.postCertificateOfService(this.props.leaseDetails.renewal_id);
    };

    createRenewalLease = async () => {
      this.props.displayLoader('renew the lease');
      this.props.postRenewalLease(
        this.props.leaseDetails.renewal_id,
        this.props.is_in_person_signing
      );
    };

    nextPage = throttle((values) => {
      if (
        this.props.pageNumber === PAGES.RENTAL_INCENTIVE &&
        this.props.selectedProperty?.hide_services_and_utilities
      ) {
        if (!get(this.props, 'leaseDetails.lease_document_types.length')) {
          this.props.goToPage(PAGES.REVIEW);
        } else {
          this.props.goToPage(PAGES.LEASE_DOCUMENTS);
        }
      } else if (
        this.props.pageNumber === PAGES.SERVICES_AND_UTILITIES &&
        !get(this.props, 'leaseDetails.lease_document_types.length')
      ) {
        // Do not display the lease_document_types if we don't have any
        this.props.goToPage(PAGES.REVIEW);
      } else if (
        this.props.pageNumber === PAGES.LEASE_TERM &&
        this.props.leaseDetails.is_manual_renewal
      ) {
        this.props.goToPage(PAGES.LEASE_PRICING);
      } else if (this.props.pageNumber < PAGES.REVIEW) {
        this.props.nextPage();
      } else if (this.props.pageNumber === PAGES.REVIEW) {
        if (featureEnabled('custom_lease_creator')) {
          if (!values.lease_template_id || !values.agent_id) {
            this.setState({
              validationErrors: {
                ...this.state.validationErrors,
                lease_template_id: !values.lease_template_id ? 'Required' : null,
                agent_id: !values.agent_id ? 'Required' : null,
              },
            });
            return;
          } else {
            this.setState({
              validationErrors: {},
            });
            return this.submitRenewal(values);
          }
        }
        this.submitRenewal(values);
      }
    }, 300);

    goBack = throttle((page) => {
      if (
        this.props.pageNumber === PAGES.REVIEW &&
        this.props.selectedProperty?.hide_services_and_utilities &&
        !get(this.props, 'leaseDetails.lease_document_types.length')
      ) {
        this.props.goToPage(PAGES.RENTAL_INCENTIVE);
      } else if (
        this.props.pageNumber === PAGES.LEASE_DOCUMENTS &&
        this.props.selectedProperty?.hide_services_and_utilities
      ) {
        this.props.goToPage(PAGES.RENTAL_INCENTIVE);
      } else if (
        this.props.pageNumber === PAGES.REVIEW &&
        !get(this.props, 'leaseDetails.lease_document_types.length')
      ) {
        // Do not display the lease_document_types if we don't have any
        this.props.goToPage(PAGES.SERVICES_AND_UTILITIES);
      } else if (page === PAGES.LEASE_PRICING && this.props.leaseDetails.is_manual_renewal) {
        this.props.goToPage(PAGES.LEASE_TERM);
      } else if (page === PAGES.LEASE_TERM && this.props.leaseDetails.is_manual_renewal) {
        this.goToRentRollPage();
      } else if (page > 1) {
        this.props.previousPage();
      } else {
        this.goToRentRollPage();
      }
    }, 300);

    changeFieldValue = (field, value) => {
      this.props.change('renewal_creator_form', field, value);
    };

    render() {
      const page = this.props.pageNumber;

      const formPageProps = {
        name: 'renewal_creator_form',
        previousPage: this.props.previousPage,
        onSubmit: this.nextPage,
      };

      const showWizardPages = this.props.leaseDetails && this.props.showPage && page <= 9;
      const classNames = 'body';
      return (
        <div className={showWizardPages ? classNames : ''} role="main">
          {showWizardPages && (
            <div className="centers">
              <div>
                <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
                  <span className="page-title">
                    <Link
                      id="maintenanceHeader"
                      style={{ color: 'inherit' }}
                      to="/companies/rent_roll"
                    >
                      {getTranslatedString('landlordPortal.renewalCreator.rentRoll')}
                    </Link>{' '}
                    > {getTranslatedString('landlordPortal.renewalCreator.renewalCreator')}{' '}
                  </span>
                  <span className="page-title" />
                </div>
                <div
                  className="container application-container"
                  ref="LeaseCreatorContainer"
                  style={{ height: '100%', overflow: 'hidden' }}
                >
                  <div className="row">
                    <CSSTransitionGroup
                      transitionName="fade_out"
                      transitionEnterTimeout={200}
                      transitionAppear={true}
                      transitionAppearTimeout={500}
                      transitionLeaveTimeout={200}
                    >
                      {page === PAGES.COMPANY_ADDRESS && this.props.companyAddress === null && (
                        <CompanyAddressWizardPage
                          {...formPageProps}
                          form="renewal_creator_form"
                          initialValues={this.props.leaseDetails}
                          previousPage={this.goToRentRollPage}
                        />
                      )}
                      {page === PAGES.YEARLY_RENEWALS && (
                        <AllowTenantsYearlyRenewalsWizardPage
                          {...formPageProps}
                          onlyShowYearly={this.props.leaseDetails.province !== 'Ontario'}
                          showN1Questions={this.props.leaseDetails.use_n1}
                          showN1NextQuestion={this.props.showN1NextQuestion}
                          displayN1NextQuestion={this.props.displayN1NextQuestion}
                          hideN1NextQuestion={this.props.hideN1NextQuestion}
                          tenantsHaveEmails={tenantsHaveEmails(this.props.leaseDetails.cotenants)}
                          is_in_person_signing={this.props.is_in_person_signing}
                        />
                      )}
                      {page === PAGES.LEASE_TERM && (
                        <LeaseTermWizardPage
                          {...formPageProps}
                          currentLeasesOfUnit={this.props.currentLeasesOfUnit}
                          unitDetails={this.props.unitDetails}
                          isRenewal
                          changeFieldValue={this.changeFieldValue}
                          leaseDetails={this.props.leaseDetails}
                        />
                      )}
                      {page === PAGES.SCHEDULE && (
                        <ScheduleWizardPage
                          {...formPageProps}
                          scheduleAs={this.props.scheduleAs}
                          openScheduleAForm={this.props.openScheduleAForm}
                          closeScheduleAForm={this.props.closeScheduleAForm}
                          showScheduleAForm={this.props.showScheduleAForm}
                        />
                      )}
                      {page === PAGES.LEASE_PRICING && (
                        <LeasePricingWizardPage
                          {...formPageProps}
                          leaseDetails={this.props.leaseDetails}
                          disableDepositSelection={featureEnabled(
                            'ui.lease_creator.disable_deposit'
                          )}
                        />
                      )}
                      {page === PAGES.RENTAL_INCENTIVE && (
                        <RentalIncentiveWizardPage
                          {...formPageProps}
                          changeFieldValue={this.changeFieldValue}
                          selectedRentAmount={this.props.selectedRentAmount}
                        />
                      )}
                      {page === PAGES.SERVICES_AND_UTILITIES && (
                        <ServicesAndUtilitiesWizardPage
                          {...formPageProps}
                          form={'renewal_creator_form'}
                          isReviewMode={false}
                        />
                      )}
                      {page === PAGES.LEASE_DOCUMENTS && (
                        <LeaseDocumentsWizardPage {...formPageProps} />
                      )}
                      {page === PAGES.REVIEW && (
                        <ReviewWizardPage
                          {...formPageProps}
                          leaseDetails={this.props.leaseDetails}
                          goToPage={this.props.goToPage}
                          showN1Questions={this.props.leaseDetails.use_n1}
                          validationErrors={this.state.validationErrors}
                          hideServicesAndUtilities={
                            this.props.selectedProperty?.hide_services_and_utilities
                          }
                        />
                      )}
                    </CSSTransitionGroup>
                  </div>
                </div>
                <div style={{ height: '170px' }} />
              </div>
              <FooterButtons
                submit={this.nextPage}
                formName="renewal_creator_form"
                submitName={getTranslatedString('landlordPortal.renewalCreator.next')}
                backAction={() => this.goBack(page)}
                disableSubmitOverride={true}
              />
            </div>
          )}
          {this.props.showPage &&
            this.props.documentToSign &&
            page === PAGES.DOCUMENT_PORTAL_IN_PERSON &&
            (this.props.documentToSign.document_type === 'N2' ||
              this.props.documentToSign.document_type === 'N1') && (
              <span>
                <DocumentPortalSwitcher
                  documentToSign={this.props.documentToSign}
                  onContinue={this.displayCertifcateOfService}
                />
              </span>
            )}
          {this.props.showPage &&
            this.props.documentToSign &&
            page === PAGES.DOCUMENT_PORTAL_IN_PERSON &&
            this.props.documentToSign.document_type === 'RENT_INCREASE_FORM' && (
              <span>
                <DocumentPortalSwitcher
                  documentToSign={this.props.documentToSign}
                  onContinue={this.createRenewalLease}
                />
              </span>
            )}
          {this.props.showPage &&
            this.props.documentToSign &&
            page === PAGES.DOCUMENT_PORTAL_SWITCHER && (
              <span>
                <DocumentPortalSwitcher
                  documentToSign={this.props.documentToSign}
                  onContinue={this.createRenewalLease}
                />
              </span>
            )}
        </div>
      );
    }
  }
);
